import { v4 as uuidv4 } from 'uuid';

export const defaultTeammateMessage = 'Join me on PI Perform. It’s a collaborative way to stay in sync.';

export function generateFormattedRecurringMeeting({
  recurringMeetingId,
  name,
  teammate,
  attendees = [],
  avatar,
  source,
  isCustom = false,
  selected = false,
}) {
  return {
    uuid: uuidv4(),
    selected,
    recurringMeetingId,
    recurringMeetingName: name,
    name: teammate?.fullName || teammate?.email || name || '',
    displayName: teammate?.displayName,
    teammateEmail: teammate?.email,
    teammateAvatar: teammate?.avatar || avatar,
    attendees,
    source,
    inviteAttendees: true,
    personalMessage: defaultTeammateMessage,
    isCustom,
  };
}
